import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { ROUTES } from '../routing/routes';
import { useAnalytics } from './useAnalytics';

// Define route patterns and screen names
const routePatterns = [
  { pattern: ROUTES.root, name: 'Root', className: 'Root' },
  { pattern: ROUTES.referral, name: 'Referral', className: 'Referral' },
  { pattern: ROUTES.onboarding.whatBringsYou, name: 'WhatBringsYou', className: 'WhatBringsYou' },
  { pattern: ROUTES.onboarding.drawHeart, name: 'DrawHeart', className: 'DrawHeart' },
  { pattern: ROUTES.onboarding.ocdThemesSelection, name: 'OcdThemesSelection', className: 'OcdThemesSelection' },
  { pattern: ROUTES.onboarding.ocdThemesDetailsSelect, name: 'OcdThemesDetailsSelect', className: 'OcdThemesDetailsSelect' },
  { pattern: ROUTES.onboarding.ocdCycleIntro, name: 'OcdCycleIntro', className: 'OcdCycleIntro' },
  { pattern: ROUTES.onboarding.ocdCycleExplain, name: 'OcdCycleExplain', className: 'OcdCycleExplain' },
  { pattern: ROUTES.onboarding.personalizingOllie, name: 'PersonalizingOllie', className: 'PersonalizingOllie' },
  { pattern: ROUTES.onboarding.highFive, name: 'HighFive', className: 'HighFive' },
  { pattern: ROUTES.onboarding.rating, name: 'OnboardingRating', className: 'OnboardingRating' },
  { pattern: ROUTES.onboarding.paywall, name: 'Paywall', className: 'PaywallPage' },
  { pattern: ROUTES.onboarding.goToAppStore, name: 'GoToAppStore', className: 'GoToAppStore' },
];

export const useScreenTracking = () => {
  const location = useLocation();
  const { setCurrentScreen } = useAnalytics();

  useEffect(() => {
    const matched = routePatterns.find(({ pattern }) =>
      matchPath({ path: pattern, end: true }, location.pathname)
    );

    if (matched) {
      setCurrentScreen(matched.pattern, matched.className);
    } else {
      setCurrentScreen('Unknown', 'UnknownPage');
    }
  }, [location.pathname]);
};
